const BORDER_COLOR = '#D9D9D9'

const grayBordered = {
  table: {
    style: {
      border: `1px solid ${BORDER_COLOR}`,
    },
  },
  headCells: {
    style: {
      backgroundColor: "#f2f2f2",
      fontSize: "0.938rem",
      fontWeight: 500,
      borderRight: `1px solid ${BORDER_COLOR}`,
      '&:last-child': {
        borderRight: 'none',
      },
      div: {
        whiteSpace: 'normal',
        overflow: 'visible',
      },
    },
  },
  cells: {
    style: {
      paddingBlock: '.3rem',
      borderRight: `1px solid ${BORDER_COLOR}`,
      '&:last-child': {
        borderRight: 'none',
      },
      div: {
        whiteSpace: "normal !important",
        overflow: "visible !important",
      },
    },
  },
};

const blackBordered = {
  table: {
    style: {
      border: `1px solid ${BORDER_COLOR}`,
    },
  },
  headCells: {
    style: {
      backgroundColor: "#1A2425",
      fontSize: "0.938rem",
      fontWeight: 500,
      color: '#fff',
      div: {
        whiteSpace: 'normal',
        overflow: 'visible',
      },
    },
  },
  cells: {
    style: {
      borderRight: `1px solid ${BORDER_COLOR}`,
      '&:last-child': {
        borderRight: 'none',
      },
    },
  },
};

const gray = {
  headCells: {
    style: {
      backgroundColor: "#f2f2f2",
      fontSize: "0.938rem",
      fontWeight: 500,
      div: {
        whiteSpace: 'normal',
        overflow: 'visible',
      },
    },
  },
  cells: {
    style: {
      paddingBlock: "0.3rem",
      div: {
        whiteSpace: "normal !important",
        overflow: "visible !important",
      },
    },
  },
}

const darkGray = {
  headCells: {
    style: {
      backgroundColor: "#D9D9D9",
      fontSize: "14px",
      fontWeight: 600,
      div: {
        whiteSpace: 'normal',
        overflow: 'visible',
      },
    },
  },
  cells: {
    style: {
      paddingBlock: "0.3rem",
    },
  },
};

const yellow = {
  headCells: {
    style: {
      backgroundColor: "#FBBD34",
      color: "#ffffff",
      fontSize: "1rem",
      fontWeight: 600,
      div: {
        whiteSpace: 'normal',
        overflow: 'visible',
      },
    },
  },
  cells: {
    style: {
      paddingBlock: ".3rem",
      div: {
        whiteSpace: "normal !important",
        overflow: "visible !important",
      },
    },
  },
};

const yellowBordered = {
  table: {
    style: {
      border: `1px solid ${BORDER_COLOR}`,
    },
  },
  headCells: {
    style: {
      backgroundColor: "#FBBD34",
      fontSize: "1rem",
      fontWeight: 600,
      color: "#ffffff",
      div: {
        whiteSpace: 'normal',
        overflow: 'visible',
      },
    },
  },
  cells: {
    style: {
      borderRight: `1px solid ${BORDER_COLOR}`,
      '&:last-child': {
        borderRight: 'none',
      },
      paddingBlock: ".3rem",
      div: {
        whiteSpace: "normal !important",
        overflow: "visible !important",
      },
    },
  },
};

export const customStyles = {
  darkGray,
  gray,
  yellow,
  "gray-bordered": grayBordered,
  "yellow-bordered": yellowBordered,
  "black-bordered": blackBordered,
};
